module.exports = __webpack_public_path__ + "img/navbar_background.e7c244fd.svg";